<template>
    <div class="nav-media-data">
        <div class="nav-media-data__list">
            <section class="data-list__section">
                <h2 class="data-list__item-name">{{ data.name }}</h2>
            </section>

            <section v-if="data.mediaType === 'image'" class="data-list__section">
                <div class="data-list__image-sample-container">
                    <img :src="data.url" alt="image sample">
                </div>
            </section>

            <section v-if="data.mediaType === 'image'" class="data-list__section">
                <data-list-item title="ID" :value="data.id || ''" />
                <data-list-item title="Path" :value="data.path || ''" />

                <!-- build manually to add link -->
                <div class="data-list__item">
                    <div class="data-list__item-title">URL</div>

                    <div class="data-list__item-value">
                        <a :href="data.url" target="_blank" rel="noreferrer noopener">{{ data.url }}</a>
                    </div>
                </div>
            </section>

            <section v-if="data.mediaType === 'image'" class="data-list__section">
                <h2 class="data-list__section-title">
                    Set Dimensions
                </h2>

                <label>
                    <div class="data-list__item-title">Width</div>

                    <input v-model.trim="width" class="data-list__input" type="number">

                    <span
                        v-show="!isWidthValid"
                        class="data-list__error"
                    >Please enter a valid number</span>
                </label>

                <label>
                    <div class="data-list__item-title">Height</div>

                    <input v-model.trim="height" class="data-list__input" type="number">

                    <span
                        v-show="!isHeightValid"
                        class="data-list__error"
                    >Please enter a valid number</span>
                </label>
            </section>

            <section v-if="data.mediaType === 'image'" class="data-list__section">
                <h2 class="data-list__section-title">Metadata</h2>

                <data-list-item title="Alt Text" :value="data.altText || ''" />
                <data-list-item title="Extension" :value="data.extension || ''" />
            </section>
        </div>

        <div v-if="data.mediaType === 'image'" class="nav-media-data__buttons">
            <button
                class="nav-media-data__button nav-media-data__button--select"
                :disabled="!hasValidSizes"
                @click="select"
            >
                SELECT
            </button>
        </div>
        <div v-if="data.mediaType !== 'folder' && data.mediaType !== 'image'" class="nav-media-data__buttons">
            <button
                class="nav-media-data__button nav-media-data__button--select"
                @click="select"
            >
                SELECT
            </button>
        </div>

        <media-folder-data v-if="data.mediaType === 'folder' || data.mediaType === ''" :data="data" @select="selectNavItem" />
    </div>
</template>

<script>
import DataListItem from '@/components/page-editor/navigation-tree/data-list-item';
import MediaFolderData from '@/components/page-editor/navigation-tree/media-folder-data';

export default {
    name: 'media-data',
    components: { DataListItem, MediaFolderData },

    props: {
        data: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            width: '',
            height: '',
            url: null,
        };
    },

    computed: {
        isHeightValid() {
            return this.isValidSize(this.height);
        },

        isWidthValid() {
            return this.isValidSize(this.width);
        },

        hasValidSizes() {
            return this.isHeightValid && this.isWidthValid;
        },
    },

    mounted() {
        // logic check to skip folders
        if (this.data && this.data.url) {
            this.url = new URL(this.data.url);
            const searchParams = new URLSearchParams(this.url.search);
            this.width = searchParams.get('w');
            this.height = searchParams.get('h');
        }
    },

    methods: {
        select() {
            if (!this.hasValidSizes) return;

            if (this.width) {
                this.url.searchParams.set('w', this.width);
                this.data.width = this.width;
            }
            if (this.height) {
                this.url.searchParams.set('h', this.height);
                this.data.height = this.height;
            }
            this.data.url = this.url.toString();

            this.$emit('select-media', this.data);
        },

        isValidSize(input) {
            if (!input) return true;

            return !Number.isNaN(Number(input)) && input > 0;
        },

        selectNavItem(id) {
            this.$emit('selectNavItem', id);
        },
    },
};
</script>

<style lang="scss">
.nav-media-data {
    padding: 15px;

    &__buttons {
        position: sticky;
        display: flex;
        bottom: 0;
    }

    &__button {
        color: var(--form-buttonColor);
        background-color: var(--form-buttonBackgroundColor);
        flex-grow: 1;
        min-height: 50px;
        border-radius: 3px;
        z-index: 2; // issue with z-index for toggles going over button
        transition: opacity 0.45s;

        &[disabled] {
            opacity: 0.5;
        }

        &:hover {
            color: var(--form-buttonHoverColor);
            background-color: var(--form-buttonHoverBackgroundColor);
        }
    }
}
</style>
